<template>
  <div id="app">
    <router-view class="main"></router-view>
    <consult-float></consult-float>
  </div>
</template>
<script>
  import ConsultFloat from '/components/ConsultFloat.vue'
  export default {
    name: 'app',
    components: { ConsultFloat }
  }
</script>
<style lang="scss" rel="stylesheet/scss">
  @import "assets/style/index.scss";

  #app {
    height: 100%;
  }

  .main {
    background: #ededed;;
  }
</style>



// WEBPACK FOOTER //
// App.vue?90a047ca